var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-graph"},[_c('div',{staticClass:"year"},[_c('span',[_vm._v(_vm._s(_vm.year))])]),_c('div',{staticClass:"dados"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }